import React, { Component } from "react";
import InfiniteScroll from "react-infinite-scroller";
import {
  Spinner,
  DetailsList,
  SpinnerSize,
  DetailsRow,
  SelectionMode,
  TextField,
} from "office-ui-fabric-react";
import axios from "axios";
import { connect } from "react-redux";
import _ from "lodash";
import "../stylesheets/assignment-logging.css";
import { LOGGING_COLUMNS } from "../constants/tableConfig";
import config from "../config";
import StatusBar from "./common/StatusBar";

const PAGE_LIMIT = 100;

class AssignmentLogging extends Component {
  constructor(props) {
    super(props);

    this.rows = {};
    this.state = {
      records: [],
      isLoading: false,
      hasMore: true,
      total: 0,
      assigned: 0,
      headerFilters: {},
      openHeaderFilters: true,
    };

    this.handleLoadLogging = this.handleLoadLogging.bind(this);
    this.renderHeaderFilter = this.renderHeaderFilter.bind(this);
    this.getColumnConfig = this.getColumnConfig.bind(this);
  }

  componentDidMount() {
    this.handleLoadLogging("", 0);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.searchBox, prevProps.searchBox)) {
      this.handleLoadLogging(this.props.searchBox, 0);
    }
  }

  handleLoadLogging(searchParams, offset) {
    if (!this.state.isLoading) {
      this.setState({
        isLoading: true,
      });

      const commonParams = {
        limit: PAGE_LIMIT,
        skip: offset !== undefined ? offset : this.state.records.length,
        searchType: _.get(
          searchParams,
          "filter",
          _.get(this.props, "searchBox.filter", "")
        ),
        q: _.get(searchParams, "text", _.get(this.props, "searchBox.text", "")),
        filterCustomer: this.state.headerFilters.customer,
        filterAssignTo: this.state.headerFilters.assignTo,
      };
      Promise.all([
        axios
          .get(`${config.apiUrl}/log/list`, {
            params: commonParams,
          })
          .then(({ data }) => {
            this.setState(({ records }) => {
              const newLogs = records.concat(data);

              return {
                records: newLogs,
                hasMore: newLogs.length >= this.limit,
              };
            });
          }),
        axios
          .get(`${config.apiUrl}/log/count-leads`, {
            params: commonParams,
          })
          .then(({ data }) => {
            this.setState({
              total: data.total,
              assigned: data.assigned,
            });
          }),
      ]).then(() => {
        this.setState({
          isLoading: false,
        });
      });
    }
  }

  renderHeaderFilter({ fieldName, name = "" }) {
    let timeout;
    return (
      <TextField
        name={fieldName}
        placeholder={`Find ${name.toLowerCase()}`}
        value={this.state.headerFilters[fieldName]}
        onChanged={(value) => {
          if (timeout) {
            clearTimeout(timeout);
          }
          this.setState(
            {
              headerFilters: {
                ...this.state.headerFilters,
                [fieldName]: value,
              },
              records: [],
              hasMore: true,
            },
            () => {
              timeout = setTimeout(() => {
                this.handleLoadLogging(this.props.searchBox, 0);
              }, 300);
            }
          );
        }}
      />
    );
  }

  getColumnConfig() {
    let columns = LOGGING_COLUMNS;

    return columns.map((col) => {
      if (["customer", "assignee"].includes(col.key)) {
        const defaultOnRender = col.onRender;
        col.onRender = (item) => {
          if (item.key === "filterRow") {
            return this.renderHeaderFilter(col);
          }
          return defaultOnRender(item);
        };
      } else if (col.onRender) {
        const defaultOnRender = col.onRender;
        col.onRender = (item) =>
          item.key !== "filterRow" &&
          (defaultOnRender ? defaultOnRender(item) : item[col.fieldName]);
      }

      return col;
    });
  }

  render() {
    const {
      records,
      isLoading,
      hasMore,
      total,
      assigned,
      openHeaderFilters,
    } = this.state;

    return (
      <div className="al-container">
        {/* <div className="al-toolbar"></div> */}
        <InfiniteScroll
          pageStart={0}
          loadMore={this.handleLoadLogging}
          useWindow
          initialLoad={false}
          loader={isLoading && <Spinner key={1} size={SpinnerSize.large} />}
          hasMore={hasMore}
          className="al-table-scroll"
        >
          <DetailsList
            setKey="_id"
            items={[
              ...(openHeaderFilters ? [{ key: "filterRow" }] : []),
              ...records,
            ]}
            columns={this.getColumnConfig()}
            selectionPreservedOnEmptyClick={true}
            selectionMode={SelectionMode.none}
            onColumnHeaderClick={() =>
              this.setState({
                openHeaderFilters: !this.state.openHeaderFilters,
              })
            }
            onRenderRow={({ item, ...remains }) => {
              return (
                <div className="al-table-row">
                  <div
                    ref={(ref) => (this.rows[item._id] = ref)}
                    className="row-hover"
                  >
                    <DetailsRow item={item} {...remains} />
                    {item.key !== "filterRow" && (
                      <div className="ms-fontColor-themePrimary al-table-row__extended">
                        {item.description ? (
                          <div>{item.description}</div>
                        ) : (
                          <i>--No description--</i>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            }}
          />
        </InfiniteScroll>
        <StatusBar>
          <span style={{ marginRight: 30 }}>Total Leads: {total}</span>

          <span>Total assigned to Closer: {assigned}</span>
        </StatusBar>
      </div>
    );
  }
}

export default connect((state) => ({
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(AssignmentLogging);



// WEBPACK FOOTER //
// ./client/components/AssignmentLogging.js